import {
    chain, find, get, isEmpty, map,
} from 'lodash';

export const TemplateTypes = {
    SYSTEM_TEMPLATE: 'systemTemplate',
    USER_TEMPLATE: 'userTemplate',
    CAMPAIGN_TEMPLATE: 'campaignTemplate',
};

export const getTemplateTypeByFlag = (template = {}) => {
    switch (true) {
        case template.isSystemTemplate: return TemplateTypes.SYSTEM_TEMPLATE;
        case template.isUserTemplate: return TemplateTypes.USER_TEMPLATE;
        case template.isCampaignTemplate: return TemplateTypes.CAMPAIGN_TEMPLATE;
        case template.isPositionCampaignTemplate: return TemplateTypes.CAMPAIGN_TEMPLATE;
        case template.isSystemCampaignTemplate: return TemplateTypes.CAMPAIGN_TEMPLATE;
        case template.isEmployerCampaignTemplate: return TemplateTypes.CAMPAIGN_TEMPLATE;
        default: return null;
    }
};

export const getLastUsedTemplates = ({
    lastUsedTemplatesHistoryData,
    systemTemplates,
    userTemplates,
    positionCampaign,
    systemCampaigns,
    employerCampaigns,
    channel,
    qty = 1,
}) => {
    const lastUsedTemplates = chain(lastUsedTemplatesHistoryData)
        .reduce((result, lastUsedTemplate) => {
            let searchTemplates = null;
            const templateType = get(lastUsedTemplate, 'type');

            switch (templateType) {
                case TemplateTypes.SYSTEM_TEMPLATE: {
                    searchTemplates = map(systemTemplates, (m, index) => ({ ...m, index }));
                    break;
                }
                case TemplateTypes.USER_TEMPLATE: {
                    searchTemplates = map(userTemplates, (m) => ({ ...m, isUserTemplate: true }));
                    break;
                }

                case TemplateTypes.CAMPAIGN_TEMPLATE: {
                    const campaignId = get(lastUsedTemplate, 'campaignId');
                    searchTemplates = chain([positionCampaign, ...systemCampaigns, ...employerCampaigns])
                        .find({ _id: campaignId })
                        .get('messages')
                        .filter({ channel })
                        .map((m, index) => ({ ...m, isCampaignTemplate: true, index }))
                        .value();
                    break;
                }
                default: searchTemplates = [];
            }

            const targetTemplate = find(searchTemplates, { name: lastUsedTemplate.name });

            if (targetTemplate) {
                result.push({
                    ...targetTemplate,
                    type: lastUsedTemplate.type,
                });
            }
            return result;
        }, [])
        .uniqBy('name')
        .orderBy('timestamp', 'desc')
        .value();

    const resultTemplates = [];

    if (!isEmpty(lastUsedTemplates)) {
        const lastUSedTemplatesData = map(lastUsedTemplates, (lastUsedTemplate) => ({
            name: lastUsedTemplate.name,
            subject: lastUsedTemplate.subject,
            body: get(lastUsedTemplate, 'template', lastUsedTemplate.body),
            isLastUsedTemplate: true,
            isCampaignTemplate: lastUsedTemplate.isCampaignTemplate,
            index: lastUsedTemplate?.index,
            isUserTemplate: lastUsedTemplate?.isUserTemplate,
        }));

        resultTemplates.push(...lastUSedTemplatesData);
    }

    return resultTemplates.slice(0, qty);
};
